import EventEmitter2 from "eventemitter2";
import { $, $$, html } from "@utils/dom";
import { on, off } from "@utils/listener";
import { INVIEW_ENTER } from "@scroll/constants";

export const CLASSNAME = "--js-site-footer-visible";


export const SELECTOR = "[data-site-footer]";
export const MENU_ITEM_SELECTOR = ".menu-item-has-children";

class SiteFooter {
  constructor(init = false) {
    this.initialized = false;

    this._onScrollCall = this._onScrollCall.bind(this);

    init ? this.init() : null;
  }

  get name() {
    return `SiteFooter`;
  }

  init() {
    this.initialized = true;
    this.el = $(SELECTOR);

    this.menuItems = [...$$(`${MENU_ITEM_SELECTOR}`, this.el)].map(el => new SiteFooterMenuItem(el, this.emitter));
    // this.menuItems[0].open();

    this._bindEvents();
  }

  _bindEvents() {
    this.emitter.on('SiteScroll.site-footer', this._onScrollCall);
  }
  _unbindEvents() {
    this.emitter.off('SiteScroll.site-footer', this._onScrollCall);
  }

  _onScrollCall(direction, obj) {
    if( obj.el !== this.el ) return;
    if(direction === INVIEW_ENTER) html.classList.add(CLASSNAME)
    else html.classList.remove(CLASSNAME)
  }

  destroy() {
    if( this.menuItems ) this.menuItems.forEach(el => el.destroy());
    this._unbindEvents();

    this.el = null;
    this.initialized = false;

    this.menuItems = null;
  }
}

class SiteFooterMenuItem extends EventEmitter2 {
  constructor(el, emitter) {
    super();

    this.el = el;
    this.emitter = emitter;
    this.opened = false;

    this.toggle = this.toggle.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.init();
  }

  destroy() {

    this._unbindEvents();

    this.opened = null;

    this.el = null;
    this.trigger = null;
    this.lotties = null;
  }
  init() {
    this.trigger = $('button, a', this.el);

    this._bindEvents();
  }

  _bindEvents() {
    on(this.trigger, "click", this.toggle);

  }
  _unbindEvents() {
    off(this.trigger, "click", this.toggle);
  }

  toggle(event){
    if(event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if(this.el.classList.contains('--opened')){
      this.close();
    } else {
      this.open();
    }

    this.emitter.emit('SiteScroll.update');
  }

  open(){
    if( this.opened ) return;

    this.opened = true;
    this.el.classList.add('--opened');
  }

  close(){
    if( ! this.opened ) return;

    this.opened = false;
    this.el.classList.remove('--opened');
  }
}

export default SiteFooter;
